import React from "react";
import Accounts from "./Accounts/Accounts";
import MyConversationsMenuItem from "./MyConversationsMenuItem";

export const MainRoutes = ( props ) => ({
    dashboard: {
        path: "/",
        icon: <i class="material-icons">insert_chart_outlined</i>,
        label: "My Dashboard"
    },
    myTasks: {
        path: "/my-tasks",
        icon: <i class="material-icons">list_alt</i>,
        label: "My Tasks"
    },
    myTimekeep: {
        path: "/my-timekeep",
        icon: <i class="material-icons">schedule</i>,
        label: "My Timekeep",
        hidden: props.loggedUser.data.userRole > 4
    },
    myConversations: {
        component: <MyConversationsMenuItem />
    },
    accounts: {
        path: "/projects",
        icon: <i class="material-icons">business</i>,
        component: props.isShowAccounts ? <Accounts history={ props.history } /> : null
    }
});

export const OtherRoutes = ( props ) => ({
    reports: {
        path: "/reports",
        icon: <i class="material-icons">library_books</i>,
        label: "Reports",
        hidden: props.loggedUser.data.userRole > 4
    },
    users: {
        path: "/users",
        icon: <i class="material-icons">people_outline</i>,
        label: "Users",
        hidden: props.loggedUser.data.userRole > 3
    },
    developer: {
        path: "/developer",
        icon: <i class="material-icons">code</i>,
        label: "Developer",
        hidden: props.loggedUser.data.userRole > 2
    },
    settings: {
        path: "/settings",
        icon: <i class="material-icons">settings</i>,
        label: "Settings",
        hidden: props.loggedUser.data.userRole > 2
    },
    legalInformationCenter: {
        path: "/legal-information-center/terms-and-conditions",
        icon: <i class="material-icons">lock_outline</i>,
        label: "Legal Information Center",
    },
    support: {
        path: "/support",
        icon: <i class="material-icons">help_outline</i>,
        label: "Contact Support",
        customClick: (e) => {
            e.preventDefault();

            $(`#contactSupportModal`).modal("show");
        }
    },
    logout: {
        path: "/logout",
        icon: <i class="material-icons">power_settings_new</i>,
        label: "Logout",
        customClick: (e) => {
            e.preventDefault();

            props.onLogout();
        }
    }
});